<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <el-form-item class="r-20" prop="account">
        <el-input
          v-model.trim="queryForm.account"
          placeholder="请输入车主账号"
          @keyup.native.enter="query"
        ></el-input>
      </el-form-item>
      <el-form-item class="r-20" prop="plate">
        <el-input
          v-model.trim="queryForm.plate"
          placeholder="请输入车牌号"
          @keyup.native.enter="query"
        ></el-input>
      </el-form-item>
      <el-button
        size="medium"
        v-if="hasPerm('vehicle:oil:consume:list')"
        type="primary"
        @click="query"
        >查询</el-button
      >
      <el-button
        size="medium"
        v-if="hasPerm('vehicle:oil:consume:list')"
        @click="reset"
        >取消</el-button
      >
    </el-form>
    <el-table
      ref="logTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      stripe
      size="mini"
      height="560px"
    >
      <el-table-column
        type="index"
        align="center"
        label="序号"
        width="55"
      ></el-table-column>
      <el-table-column prop="name" label="车辆绑定人"></el-table-column>
      <el-table-column
        prop="account"
        label="车主账号"
        min-width="120 "
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="plate"
        label="车牌号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oilElectricTotal"
        label="总发电油耗（L）"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oilDrivingTotal"
        label="总行驶油耗（L）"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="lastTime"
        label="上次结算时间"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="interval"
        label="当前间隔时长"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oilElectric"
        label="当前累计发电油耗（L）"
        min-width="160"
      ></el-table-column>
      <el-table-column
        prop="oilDriving"
        label="当前累计行驶油耗（L）"
        min-width="160"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('vehicle:oil:consume:finish')"
            @click="settleOil(scope.row)"
            >结算</el-button
          >
          <el-button
            type="text"
            v-if="hasPerm('vehicle:oil:consume:record')"
            @click="checkRecord(scope.row)"
            >查看记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <el-dialog
      :title="consumeTitle"
      :visible.sync="consumeDialogVisible"
      class="consumeDialog"
      width="600px"
    >
      <el-row class="consumePoint">确认结算后以下数据将重新开始累计：</el-row>
      <el-row class="consumeContent">
        <el-row class="consumeDesc">
          <el-col :span="8">当前间隔时长</el-col>
          <el-col :span="8">当前累计发电油耗（L）</el-col>
          <el-col :span="8">当前累计行驶油耗（L）</el-col>
        </el-row>
        <el-row class="consumeData">
          <el-col :span="8">{{ consumeData.interval || 0 }}</el-col>
          <el-col :span="8">{{ consumeData.oilElectric || 0 }}</el-col>
          <el-col :span="8">{{ consumeData.oilDriving || 0 }}</el-col>
        </el-row>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSettle(consumeData.id)"
          >确认结算</el-button
        >
        <el-button @click="consumeDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="查看记录"
      :visible.sync="recordDialogVisible"
      class="recordDialog"
      width="1200px"
    >
      <el-row class="recordUser">
        {{ recordUser }}
      </el-row>
      <el-row class="recordTable">
        <el-table
          ref="logTable"
          :data="recordTableData"
          tooltip-effect="dark"
          style="width: 100%"
          stripe
          size="mini"
          height="560px"
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column prop="addTime" label="结算时间"></el-table-column>
          <el-table-column
            prop="duration"
            label="间隔时长"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="oilElectric"
            label="累计发电油耗（L）"
          ></el-table-column>
          <el-table-column
            prop="oilDriving"
            label="累计行驶油耗（L）"
          ></el-table-column>
        </el-table>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      consumeTitle: "",
      consumeDialogVisible: false,
      consumeData: {},
      recordDialogVisible: false,
      recordUser: "",
      queryForm: {
        account: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      recordTableData: [],
      tableData: [],
    };
  },
  created() {
    this.getOilConsumeList();
  },
  methods: {
    query() {
      this.getOilConsumeList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getOilConsumeList();
    },
    settleOil(data) {
      this.consumeData = data;
      this.consumeTitle = data.name + "（" + data.plate + "）";
      this.consumeDialogVisible = true;
    },
    async confirmSettle(id) {
      let _this = this;
      let { data: res } = await _this.$axios.post(
        `/api/vehicle/oil/consume/finish/${id}`
      );
      if (res.code == 1) {
        _this.consumeDialogVisible = false;
        _this.$message.success("结算成功");
        _this.getOilConsumeList();
      }
    },
    async checkRecord(data) {
      let id = data.id;
      let _this = this;
      _this.recordUser = data.name + "（" + data.plate + "）";
      _this.recordDialogVisible = true;
      let { data: res } = await _this.$axios.get(
        `/api/vehicle/oil/consume/record/${id}`
      );
      if (res.code == 1) {
        _this.recordTableData = res.data.consumeRecordList;
      }
    },
    async getOilConsumeList() {
      let parm = {};
      parm.account = this.queryForm.account;
      parm.plate = this.queryForm.plate;
      parm.pageSize = this.limit;
      parm.pageNum = this.currentPage;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/oil/consume/list",
        {
          params: parm,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOilConsumeList();
    },
    handleSizeChange(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  background-color: #fff;
  padding: 0 20px;
}
.consumeDialog {
  font-size: 14px;
  font-family: Microsoft YaHei;
  .consumePoint {
    color: #fa1d1d;
    margin-bottom: 10px !important;
  }
  .consumeContent {
    width: 100%;
    .consumeDesc {
      padding: 0 20px;
      line-height: 48px;
      background: #f4f4f4;
    }
    .consumeData {
      padding: 0 20px;
      line-height: 48px;
    }
  }
}
.recordUser {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-bottom: 10px !important;
}
</style>
